import { Checkbox } from 'antd5';
import styled from 'styled-components';

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-wrapper.ant-checkbox-group-item {
    display: block;
  }

  .ant-checkbox {
    display: inline-block;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;
